import { combineReducers } from 'redux';

import { FlowchartState, FlowchartActionTypes } from './types';
import { piecesReducer } from './pieces/reducer';
import { variablesReducer } from './variables/reducer';

export const flowchartReducer = combineReducers<FlowchartState, FlowchartActionTypes>({
    pieces: piecesReducer,
    variables: variablesReducer,
});